const gtmManager = {
  install(Vue, options = {}) {

    Vue.prototype.$analytics = {
      pushEvent: function (evCategory, evAction, evLabel="", goToLink="", familyModel="",colour) {
        window.dataLayer = window.dataLayer || [];

        let state = {
          'event': 'GAevent',
          'eventCategory': evCategory,
          'eventAction': evAction
        };

        if (evLabel) {
          state['eventLabel'] = evLabel;
        }

        if (goToLink) {
          state['eventCallback'] = function() {
            document.location = goToLink;
          };
          state['eventTimeout'] = 2000;
        }
  
        if (familyModel) {
          state['familyModel'] = familyModel;
        }

        if (colour) {
          state['colour'] = colour;
        }

        dataLayer.push(state);
      },

      sendGtm: function({event, eventCategory, eventAction, eventLabel}){
        console.log("sendGtm:");
        window.dataLayer = window.dataLayer || [];
        dataLayer.push(...arguments);
      }
    };
  }
};

export default gtmManager;